import React, { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import { getFromDB } from "../../component/indexedDB/indexedDB"; // Adjust the import path as necessary
import QuestionPublicLink from "../../component/PublicLink/PublicLink";
import { QuizButton } from "../../types/GeneralStyles";
import {
  ResultScore,
  ResultScreen,
  QuizResultDiv,
  QuizResultFlexContainer,
  QuizResultDescription,
  SimpleResultQuizResultScore,
  QuizEndResultText,
  SimpleResultWebpageItem,
  SimpleResultQuizResultScoreSub,
} from "../Webpage.components";

const SimpleResult = ({
  result,
  oriQuiz,
  overViewPage,
  enableNavigationButton,
  resetQuiz,
}) => {
  const [answers, setAnswers] = useState({});
  const [attempts, setAttempts] = useState({});
  const [dbName, setDbName] = useState("");
  const [sortedQuestions, setSortedQuestions] = useState([]);
  const [databases, setDatabases] = useState([]);
  const [activeDatabase, setActiveDatabase] = useState("");

  // Fetch answers and attempts from IndexedDB when the component mounts
  useEffect(() => {
    // Enable the NavigationButton
    enableNavigationButton();
    const fetchAnswersAndAttempts = async () => {
      const dbName = sessionStorage.getItem("currentSessionName") || "Leerling";
      const data = await getFromDB(dbName);
      const answersMap = data.reduce((acc, item) => {
        acc[item.id] = item.answer;
        return acc;
      }, {});
      setAnswers(answersMap);
      const attemptsMap = data.reduce((acc, item) => {
        acc[item.id] = item.attempts;
        return acc;
      }, {});
      setAttempts(attemptsMap);
    };
    fetchAnswersAndAttempts();
  }, []); // Empty dependency array ensures this runs once when the component mounts

  // Sort questions based on component_order whenever result.component_order or oriQuiz.Quizes changes
  useEffect(() => {
    const sorted = result.component_order.map((orderItem) => {
      return oriQuiz.Quizes.find(
        (question) => question.quiz_item_id === orderItem.quiz_item_id
      );
    });

    setSortedQuestions(sorted);
    setDbName(sessionStorage.getItem("currentSessionName") || "Leerling");
  }, [result.component_order, oriQuiz.Quizes]); // Dependencies to rerun this effect
  return (
    <ResultScreen
      style={{ marginTop: "10px" }}
      bgColor={result.theme_color}
      bgVisible={overViewPage}
      id={result.results_item_id}
    >
      <QuestionPublicLink
        overViewPage={overViewPage}
        type="result"
        quiz_item_id={result.results_item_id}
      />
      <ResultScore
        score={false}
        scoreVisible={false}
        endTotalScore={false}
        startCalculation={true}
      />
      <QuizResultFlexContainer>
        <QuizResultDescription
          bgColor={result.theme_color}
          style={{ flex: "100%" }}
        >
          <ReactMarkdown>{result.description}</ReactMarkdown>
        </QuizResultDescription>

        {sortedQuestions.map((question, index) => {
          const answer = answers[question.quiz_item_id] || [];
          const attempt = attempts[question.quiz_item_id] || [];
          return (
            <SimpleResultWebpageItem
              bgColor={result.theme_color}
              txtColor={result.theme_text_color}
              overViewPage={overViewPage}
              key={index}
              className={
                result.component_order[index].start_on_new_page ? "newPage" : ""
              }
              question={question}
              answer={answer}
              attempt={attempt}
            />
          );
        })}

        <QuizResultDiv style={{ borderWidth: "0" }} bgVisible={overViewPage}>
          <QuizEndResultText>
            <SimpleResultQuizResultScore>
              <ResultScore
                score={false}
                scoreVisible={true}
                endTotalScore={true}
              />
              <SimpleResultQuizResultScoreSub>
                /{result.max_total_score}
              </SimpleResultQuizResultScoreSub>
            </SimpleResultQuizResultScore>
          </QuizEndResultText>
        </QuizResultDiv>
      </QuizResultFlexContainer>
      {result.reset_quiz_button_visible === true && (
      <QuizButton
        className="screenVisible"
        bgColor={result.theme_color}
        txtColor={result.theme_text_color}
        onClick={resetQuiz} // Use resetQuiz directly
      >
        Start opnieuw
      </QuizButton>
      )}
    </ResultScreen>
  );
};

export default SimpleResult;
